/**
 * Feature detects modern viewport units and provides fallback
 */
export const modernViewportUnit = (val, unit) => {
    if (typeof window === 'undefined' || !window.CSS.supports) {
        return `${val}${unit}`;
    }
    const supportModernViewportUnit = window.CSS.supports('height', `100${unit}`);
    // Remove "l", "s" or "d" from unit to get fallback unit
    const fallbackUnit = unit.slice(1);
    return supportModernViewportUnit ? `${val}${unit}` : `${val}${fallbackUnit}`;
};
